// Pure display helpers for the read-only Data screen, ported verbatim from the
// mobile app's Data sub-screens so the web shows the same derived values. No
// darwin_core state here — callers pass already-selected primitives.

// Heat-pump "Service due", from HeatPump.js. serviceInterval/serviceTime are in
// months; the difference is how long until the next service.
export function formatServiceDue(serviceInterval, serviceTime) {
  if (serviceTime == null || serviceInterval == null) {
    return undefined;
  }
  if (serviceInterval === 0) {
    return 'Service date not set';
  }
  const monthsFromLastService = serviceInterval - serviceTime;
  if (monthsFromLastService === 0) {
    return 'Now';
  }
  if (monthsFromLastService < 0) {
    return 'Service overdue';
  }
  return `${monthsFromLastService} ${monthsFromLastService === 1 ? 'month' : 'months'}`;
}

// Thermostat radio signal, from Thermostat.js signalToBars. Returns a label plus
// a 0–4 strength for a bar indicator.
export function signalToBars(rssi) {
  if (rssi !== undefined && rssi !== null) {
    if (rssi <= -76) {
      return { text: 'Low', strength: 1 };
    }
    if (rssi < -66) {
      return { text: 'Ok', strength: 2 };
    }
    if (rssi < -56) {
      return { text: 'Good', strength: 3 };
    }
    if (rssi < 0) {
      return { text: 'Very Good', strength: 4 };
    }
  }
  return { text: 'Unknown', strength: 0 };
}

// Optimised-start/stop max time, from Thermostat.js formatOptimisationTime. Takes
// the { hours, minutes } that darwin_core's splitTimeDuration produces.
export function formatOptimisationTime({ hours, minutes } = {}) {
  if (!hours && !minutes) {
    return 'Off';
  }
  const parts = [];
  if (hours > 0) {
    parts.push(`${hours}hrs`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}mins`);
  }
  return parts.join(' ');
}

// Interface "Weather Compensation", from Interface.js. Enabled only for a boiler
// (SI) home with the heat curve on; the value shown is the curve number / 100.
export function weatherCompText(home) {
  return home?.weatherCompensationEnabled && home?.si?.heatCurveEnabled
    ? home.si.heatCurveNumber / 100
    : 'Disabled';
}
